/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArchiveTarget } from '../fn/supervisor/archive-target';
import { ArchiveTarget$Params } from '../fn/supervisor/archive-target';
import { BehaviorGoalModel } from '../models/behavior-goal-model';
import { ChangeLogModel } from '../models/change-log-model';
import { CreateCustomPromptCodes } from '../fn/supervisor/create-custom-prompt-codes';
import { CreateCustomPromptCodes$Params } from '../fn/supervisor/create-custom-prompt-codes';
import { DeletePatientInstructionAttachment } from '../fn/supervisor/delete-patient-instruction-attachment';
import { DeletePatientInstructionAttachment$Params } from '../fn/supervisor/delete-patient-instruction-attachment';
import { DeletePatientReminder } from '../fn/supervisor/delete-patient-reminder';
import { DeletePatientReminder$Params } from '../fn/supervisor/delete-patient-reminder';
import { DeleteTargetAttachment } from '../fn/supervisor/delete-target-attachment';
import { DeleteTargetAttachment$Params } from '../fn/supervisor/delete-target-attachment';
import { DeleteTargetTemplate } from '../fn/supervisor/delete-target-template';
import { DeleteTargetTemplate$Params } from '../fn/supervisor/delete-target-template';
import { DuplicatePatientTarget } from '../fn/supervisor/duplicate-patient-target';
import { DuplicatePatientTarget$Params } from '../fn/supervisor/duplicate-patient-target';
import { GeneralAttachmentModel } from '../models/general-attachment-model';
import { GetAllPatients } from '../fn/supervisor/get-all-patients';
import { GetAllPatients$Params } from '../fn/supervisor/get-all-patients';
import { GetBehaviorRawData } from '../fn/supervisor/get-behavior-raw-data';
import { GetBehaviorRawData$Params } from '../fn/supervisor/get-behavior-raw-data';
import { GetChangeLog } from '../fn/supervisor/get-change-log';
import { GetChangeLog$Params } from '../fn/supervisor/get-change-log';
import { GetCurrentMaintenanceCriteriaFull } from '../fn/supervisor/get-current-maintenance-criteria-full';
import { GetCurrentMaintenanceCriteriaFull$Params } from '../fn/supervisor/get-current-maintenance-criteria-full';
import { GetMaintananceLevels } from '../fn/supervisor/get-maintanance-levels';
import { GetMaintananceLevels$Params } from '../fn/supervisor/get-maintanance-levels';
import { GetMaintenanceCriteriaFull } from '../fn/supervisor/get-maintenance-criteria-full';
import { GetMaintenanceCriteriaFull$Params } from '../fn/supervisor/get-maintenance-criteria-full';
import { GetMasteryCriteria } from '../fn/supervisor/get-mastery-criteria';
import { GetMasteryCriteria$Params } from '../fn/supervisor/get-mastery-criteria';
import { GetPatientBehaviorGoals } from '../fn/supervisor/get-patient-behavior-goals';
import { GetPatientBehaviorGoals$Params } from '../fn/supervisor/get-patient-behavior-goals';
import { GetPatientBIPInterventions } from '../fn/supervisor/get-patient-bip-interventions';
import { GetPatientBIPInterventions$Params } from '../fn/supervisor/get-patient-bip-interventions';
import { GetPatientInstructionAttachments } from '../fn/supervisor/get-patient-instruction-attachments';
import { GetPatientInstructionAttachments$Params } from '../fn/supervisor/get-patient-instruction-attachments';
import { GetPatientInstructions } from '../fn/supervisor/get-patient-instructions';
import { GetPatientInstructions$Params } from '../fn/supervisor/get-patient-instructions';
import { GetPatientNotes } from '../fn/supervisor/get-patient-notes';
import { GetPatientNotes$Params } from '../fn/supervisor/get-patient-notes';
import { GetPatientOverviewData } from '../fn/supervisor/get-patient-overview-data';
import { GetPatientOverviewData$Params } from '../fn/supervisor/get-patient-overview-data';
import { GetPatientPlaylists } from '../fn/supervisor/get-patient-playlists';
import { GetPatientPlaylists$Params } from '../fn/supervisor/get-patient-playlists';
import { GetPatientPrograms } from '../fn/supervisor/get-patient-programs';
import { GetPatientPrograms$Params } from '../fn/supervisor/get-patient-programs';
import { GetPatientProgramsDelta } from '../fn/supervisor/get-patient-programs-delta';
import { GetPatientProgramsDelta$Params } from '../fn/supervisor/get-patient-programs-delta';
import { GetPatientProgramContent } from '../fn/supervisor/get-patient-program-content';
import { GetPatientProgramContent$Params } from '../fn/supervisor/get-patient-program-content';
import { GetPatientPlaylistContent } from '../fn/supervisor/get-patient-playlist-content';
import { GetPatientPlaylistContent$Params } from '../fn/supervisor/get-patient-playlist-content';
import { GetPatientReminders } from '../fn/supervisor/get-patient-reminders';
import { GetPatientReminders$Params } from '../fn/supervisor/get-patient-reminders';
import { GetPatientSkillAcquisitionGoals } from '../fn/supervisor/get-patient-skill-acquisition-goals';
import { GetPatientSkillAcquisitionGoals$Params } from '../fn/supervisor/get-patient-skill-acquisition-goals';
import { GetPatientSkillAcquisitionObjectives } from '../fn/supervisor/get-patient-skill-acquisition-objectives';
import { GetPatientSkillAcquisitionObjectives$Params } from '../fn/supervisor/get-patient-skill-acquisition-objectives';
import { GetPatientTargets } from '../fn/supervisor/get-patient-targets';
import { GetPatientTargets$Params } from '../fn/supervisor/get-patient-targets';
import { GetPatientTargetsDelta } from '../fn/supervisor/get-patient-targets-delta';
import { GetPatientTargetsDelta$Params } from '../fn/supervisor/get-patient-targets-delta';
import { GetPatientTargetContent } from '../fn/supervisor/get-patient-target-content';
import { GetPatientTargetContent$Params } from '../fn/supervisor/get-patient-target-content';
import { GetPatientTreatmentGoals } from '../fn/supervisor/get-patient-treatment-goals';
import { GetPatientTreatmentGoals$Params } from '../fn/supervisor/get-patient-treatment-goals';
import { GetProbeCriteria } from '../fn/supervisor/get-probe-criteria';
import { GetProbeCriteria$Params } from '../fn/supervisor/get-probe-criteria';
import { GetPromptCodes } from '../fn/supervisor/get-prompt-codes';
import { GetPromptCodes$Params } from '../fn/supervisor/get-prompt-codes';
import { GetPromptSchedules } from '../fn/supervisor/get-prompt-schedules';
import { GetPromptSchedules$Params } from '../fn/supervisor/get-prompt-schedules';
import { GetSkillAreas } from '../fn/supervisor/get-skill-areas';
import { GetSkillAreas$Params } from '../fn/supervisor/get-skill-areas';
import { GetTargetAttachments } from '../fn/supervisor/get-target-attachments';
import { GetTargetAttachments$Params } from '../fn/supervisor/get-target-attachments';
import { GetTargetRawData } from '../fn/supervisor/get-target-raw-data';
import { GetTargetRawData$Params } from '../fn/supervisor/get-target-raw-data';
import { GetTargetTemplates } from '../fn/supervisor/get-target-templates';
import { GetTargetTemplates$Params } from '../fn/supervisor/get-target-templates';
import { ImportAntecedentsFromBIP } from '../fn/supervisor/import-antecedents-from-bip';
import { ImportAntecedentsFromBIP$Params } from '../fn/supervisor/import-antecedents-from-bip';
import { ImportBehaviorsFromBIP } from '../fn/supervisor/import-behaviors-from-bip';
import { ImportBehaviorsFromBIP$Params } from '../fn/supervisor/import-behaviors-from-bip';
import { ImportConsequencesFromBIP } from '../fn/supervisor/import-consequences-from-bip';
import { ImportConsequencesFromBIP$Params } from '../fn/supervisor/import-consequences-from-bip';
import { ImportPatientTargetsFromFile } from '../fn/supervisor/import-patient-targets-from-file';
import { ImportPatientTargetsFromFile$Params } from '../fn/supervisor/import-patient-targets-from-file';
import { ImportProgramsFromBSP } from '../fn/supervisor/import-programs-from-bsp';
import { ImportProgramsFromBSP$Params } from '../fn/supervisor/import-programs-from-bsp';
import { ImportSkillAreasFromBSP } from '../fn/supervisor/import-skill-areas-from-bsp';
import { ImportSkillAreasFromBSP$Params } from '../fn/supervisor/import-skill-areas-from-bsp';
import { MaintananceLevelModel } from '../models/maintanance-level-model';
import { MaintenanceCriteriaFullModel } from '../models/maintenance-criteria-full-model';
import { MarkMultiplePatientPlaylistsAsDeleted } from '../fn/supervisor/mark-multiple-patient-playlists-as-deleted';
import { MarkMultiplePatientPlaylistsAsDeleted$Params } from '../fn/supervisor/mark-multiple-patient-playlists-as-deleted';
import { MarkMultiplePatientProgramsAsDeleted } from '../fn/supervisor/mark-multiple-patient-programs-as-deleted';
import { MarkMultiplePatientProgramsAsDeleted$Params } from '../fn/supervisor/mark-multiple-patient-programs-as-deleted';
import { MarkMultiplePatientTargetsAsDeleted } from '../fn/supervisor/mark-multiple-patient-targets-as-deleted';
import { MarkMultiplePatientTargetsAsDeleted$Params } from '../fn/supervisor/mark-multiple-patient-targets-as-deleted';
import { MarkPatientPlaylistAsDeleted } from '../fn/supervisor/mark-patient-playlist-as-deleted';
import { MarkPatientPlaylistAsDeleted$Params } from '../fn/supervisor/mark-patient-playlist-as-deleted';
import { MarkPatientProgramAsDeleted } from '../fn/supervisor/mark-patient-program-as-deleted';
import { MarkPatientProgramAsDeleted$Params } from '../fn/supervisor/mark-patient-program-as-deleted';
import { MarkPatientTargetAsDeleted } from '../fn/supervisor/mark-patient-target-as-deleted';
import { MarkPatientTargetAsDeleted$Params } from '../fn/supervisor/mark-patient-target-as-deleted';
import { MarkProgramNoteAsRead } from '../fn/supervisor/mark-program-note-as-read';
import { MarkProgramNoteAsRead$Params } from '../fn/supervisor/mark-program-note-as-read';
import { MarkPromptScheduleAsDeleted } from '../fn/supervisor/mark-prompt-schedule-as-deleted';
import { MarkPromptScheduleAsDeleted$Params } from '../fn/supervisor/mark-prompt-schedule-as-deleted';
import { MarkSkillAreaAsDeleted } from '../fn/supervisor/mark-skill-area-as-deleted';
import { MarkSkillAreaAsDeleted$Params } from '../fn/supervisor/mark-skill-area-as-deleted';
import { MarkTargetNoteAsRead } from '../fn/supervisor/mark-target-note-as-read';
import { MarkTargetNoteAsRead$Params } from '../fn/supervisor/mark-target-note-as-read';
import { MasteryCriteriaModel } from '../models/mastery-criteria-model';
import { MergeBehaviors } from '../fn/supervisor/merge-behaviors';
import { MergeBehaviors$Params } from '../fn/supervisor/merge-behaviors';
import { MergeTargets } from '../fn/supervisor/merge-targets';
import { MergeTargets$Params } from '../fn/supervisor/merge-targets';
import { MovePromptCodeDown } from '../fn/supervisor/move-prompt-code-down';
import { MovePromptCodeDown$Params } from '../fn/supervisor/move-prompt-code-down';
import { MovePromptCodeUp } from '../fn/supervisor/move-prompt-code-up';
import { MovePromptCodeUp$Params } from '../fn/supervisor/move-prompt-code-up';
import { MoveSessionData } from '../fn/supervisor/move-session-data';
import { MoveSessionData$Params } from '../fn/supervisor/move-session-data';
import { PatientBehaviorDataModel } from '../models/patient-behavior-data-model';
import { PatientInstructionsModel } from '../models/patient-instructions-model';
import { PatientModel } from '../models/patient-model';
import { PatientNotesModel } from '../models/patient-notes-model';
import { PatientOverviewDataModel } from '../models/patient-overview-data-model';
import { PatientPlaylistModel } from '../models/patient-playlist-model';
import { PatientProgramModel } from '../models/patient-program-model';
import { PatientProgramsDeltaResponseModel } from '../models/patient-programs-delta-response-model';
import { PatientReminderModel } from '../models/patient-reminder-model';
import { PatientTargetDataModel } from '../models/patient-target-data-model';
import { PatientTargetModel } from '../models/patient-target-model';
import { PatientTargetsDeltaResponseModel } from '../models/patient-targets-delta-response-model';
import { ProbeCriteriaModel } from '../models/probe-criteria-model';
import { PromptCodeModel } from '../models/prompt-code-model';
import { PromptScheduleModel } from '../models/prompt-schedule-model';
import { RemoveCustomMaintenanceCriteria } from '../fn/supervisor/remove-custom-maintenance-criteria';
import { RemoveCustomMaintenanceCriteria$Params } from '../fn/supervisor/remove-custom-maintenance-criteria';
import { RemoveCustomMasteryCriteria } from '../fn/supervisor/remove-custom-mastery-criteria';
import { RemoveCustomMasteryCriteria$Params } from '../fn/supervisor/remove-custom-mastery-criteria';
import { RestorePatientPlaylist } from '../fn/supervisor/restore-patient-playlist';
import { RestorePatientPlaylist$Params } from '../fn/supervisor/restore-patient-playlist';
import { RestorePatientProgram } from '../fn/supervisor/restore-patient-program';
import { RestorePatientProgram$Params } from '../fn/supervisor/restore-patient-program';
import { RestorePatientReminder } from '../fn/supervisor/restore-patient-reminder';
import { RestorePatientReminder$Params } from '../fn/supervisor/restore-patient-reminder';
import { RestorePatientTarget } from '../fn/supervisor/restore-patient-target';
import { RestorePatientTarget$Params } from '../fn/supervisor/restore-patient-target';
import { RestorePromptSchedule } from '../fn/supervisor/restore-prompt-schedule';
import { RestorePromptSchedule$Params } from '../fn/supervisor/restore-prompt-schedule';
import { RestoreSkillArea } from '../fn/supervisor/restore-skill-area';
import { RestoreSkillArea$Params } from '../fn/supervisor/restore-skill-area';
import { SaveMaintenanceCriteriaFull } from '../fn/supervisor/save-maintenance-criteria-full';
import { SaveMaintenanceCriteriaFull$Params } from '../fn/supervisor/save-maintenance-criteria-full';
import { SaveMasteryCriteria } from '../fn/supervisor/save-mastery-criteria';
import { SaveMasteryCriteria$Params } from '../fn/supervisor/save-mastery-criteria';
import { SavePatientInstructions } from '../fn/supervisor/save-patient-instructions';
import { SavePatientInstructions$Params } from '../fn/supervisor/save-patient-instructions';
import { SavePatientNotes } from '../fn/supervisor/save-patient-notes';
import { SavePatientNotes$Params } from '../fn/supervisor/save-patient-notes';
import { SavePatientPlaylist } from '../fn/supervisor/save-patient-playlist';
import { SavePatientPlaylist$Params } from '../fn/supervisor/save-patient-playlist';
import { SavePatientProgram } from '../fn/supervisor/save-patient-program';
import { SavePatientProgram$Params } from '../fn/supervisor/save-patient-program';
import { SavePatientReminder } from '../fn/supervisor/save-patient-reminder';
import { SavePatientReminder$Params } from '../fn/supervisor/save-patient-reminder';
import { SavePatientTarget } from '../fn/supervisor/save-patient-target';
import { SavePatientTarget$Params } from '../fn/supervisor/save-patient-target';
import { SavePlaylistOrder } from '../fn/supervisor/save-playlist-order';
import { SavePlaylistOrder$Params } from '../fn/supervisor/save-playlist-order';
import { SaveProbeCriteria } from '../fn/supervisor/save-probe-criteria';
import { SaveProbeCriteria$Params } from '../fn/supervisor/save-probe-criteria';
import { SaveProgramOrder } from '../fn/supervisor/save-program-order';
import { SaveProgramOrder$Params } from '../fn/supervisor/save-program-order';
import { SavePromptCode } from '../fn/supervisor/save-prompt-code';
import { SavePromptCode$Params } from '../fn/supervisor/save-prompt-code';
import { SavePromptSchedule } from '../fn/supervisor/save-prompt-schedule';
import { SavePromptSchedule$Params } from '../fn/supervisor/save-prompt-schedule';
import { SaveSkillArea } from '../fn/supervisor/save-skill-area';
import { SaveSkillArea$Params } from '../fn/supervisor/save-skill-area';
import { SaveTargetOrder } from '../fn/supervisor/save-target-order';
import { SaveTargetOrder$Params } from '../fn/supervisor/save-target-order';
import { SaveTargetTemplate } from '../fn/supervisor/save-target-template';
import { SaveTargetTemplate$Params } from '../fn/supervisor/save-target-template';
import { SkillAcquisitionGoalModel } from '../models/skill-acquisition-goal-model';
import { SkillAcquisitionObjectiveModel } from '../models/skill-acquisition-objective-model';
import { SkillAreaModel } from '../models/skill-area-model';
import { TargetTemplateModel } from '../models/target-template-model';
import { TreatmentGoalModel } from '../models/treatment-goal-model';
import { UpdateTargetInstructions } from '../fn/supervisor/update-target-instructions';
import { UpdateTargetInstructions$Params } from '../fn/supervisor/update-target-instructions';
import { UpdateTargetStatus } from '../fn/supervisor/update-target-status';
import { UpdateTargetStatus$Params } from '../fn/supervisor/update-target-status';
import { UploadPatientInstructionsAttachment } from '../fn/supervisor/upload-patient-instructions-attachment';
import { UploadPatientInstructionsAttachment$Params } from '../fn/supervisor/upload-patient-instructions-attachment';
import { UploadTargetAttachment } from '../fn/supervisor/upload-target-attachment';
import { UploadTargetAttachment$Params } from '../fn/supervisor/upload-target-attachment';

@Injectable({ providedIn: 'root' })
export class SupervisorApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSupervisorGetTargetTemplatesGet()` */
  static readonly ApiSupervisorGetTargetTemplatesGetPath = '/api/Supervisor/GetTargetTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTargetTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetTemplates$Response(params?: GetTargetTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TargetTemplateModel>>> {
    return GetTargetTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTargetTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetTemplates(params?: GetTargetTemplates$Params, context?: HttpContext): Observable<Array<TargetTemplateModel>> {
    return this.GetTargetTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TargetTemplateModel>>): Array<TargetTemplateModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveTargetTemplatePost()` */
  static readonly ApiSupervisorSaveTargetTemplatePostPath = '/api/Supervisor/SaveTargetTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTargetTemplate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveTargetTemplate$Response(params?: SaveTargetTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<TargetTemplateModel>> {
    return SaveTargetTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTargetTemplate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveTargetTemplate(params?: SaveTargetTemplate$Params, context?: HttpContext): Observable<TargetTemplateModel> {
    return this.SaveTargetTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TargetTemplateModel>): TargetTemplateModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorDeleteTargetTemplatePost()` */
  static readonly ApiSupervisorDeleteTargetTemplatePostPath = '/api/Supervisor/DeleteTargetTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteTargetTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteTargetTemplate$Response(params?: DeleteTargetTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteTargetTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteTargetTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteTargetTemplate(params?: DeleteTargetTemplate$Params, context?: HttpContext): Observable<void> {
    return this.DeleteTargetTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPromptSchedulesGet()` */
  static readonly ApiSupervisorGetPromptSchedulesGetPath = '/api/Supervisor/GetPromptSchedules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPromptSchedules()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPromptSchedules$Response(params?: GetPromptSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromptScheduleModel>>> {
    return GetPromptSchedules(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPromptSchedules$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPromptSchedules(params?: GetPromptSchedules$Params, context?: HttpContext): Observable<Array<PromptScheduleModel>> {
    return this.GetPromptSchedules$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PromptScheduleModel>>): Array<PromptScheduleModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePromptSchedulePost()` */
  static readonly ApiSupervisorSavePromptSchedulePostPath = '/api/Supervisor/SavePromptSchedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePromptSchedule()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePromptSchedule$Response(params?: SavePromptSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<PromptScheduleModel>> {
    return SavePromptSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePromptSchedule$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePromptSchedule(params?: SavePromptSchedule$Params, context?: HttpContext): Observable<PromptScheduleModel> {
    return this.SavePromptSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<PromptScheduleModel>): PromptScheduleModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkPromptScheduleAsDeletedPost()` */
  static readonly ApiSupervisorMarkPromptScheduleAsDeletedPostPath = '/api/Supervisor/MarkPromptScheduleAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkPromptScheduleAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPromptScheduleAsDeleted$Response(params?: MarkPromptScheduleAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkPromptScheduleAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkPromptScheduleAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPromptScheduleAsDeleted(params?: MarkPromptScheduleAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkPromptScheduleAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRestorePromptSchedulePost()` */
  static readonly ApiSupervisorRestorePromptSchedulePostPath = '/api/Supervisor/RestorePromptSchedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestorePromptSchedule()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePromptSchedule$Response(params?: RestorePromptSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestorePromptSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestorePromptSchedule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePromptSchedule(params?: RestorePromptSchedule$Params, context?: HttpContext): Observable<void> {
    return this.RestorePromptSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPromptCodesGet()` */
  static readonly ApiSupervisorGetPromptCodesGetPath = '/api/Supervisor/GetPromptCodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPromptCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPromptCodes$Response(params?: GetPromptCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromptCodeModel>>> {
    return GetPromptCodes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPromptCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPromptCodes(params?: GetPromptCodes$Params, context?: HttpContext): Observable<Array<PromptCodeModel>> {
    return this.GetPromptCodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PromptCodeModel>>): Array<PromptCodeModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePromptCodePost()` */
  static readonly ApiSupervisorSavePromptCodePostPath = '/api/Supervisor/SavePromptCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePromptCode()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePromptCode$Response(params?: SavePromptCode$Params, context?: HttpContext): Observable<StrictHttpResponse<PromptCodeModel>> {
    return SavePromptCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePromptCode$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePromptCode(params?: SavePromptCode$Params, context?: HttpContext): Observable<PromptCodeModel> {
    return this.SavePromptCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<PromptCodeModel>): PromptCodeModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorCreateCustomPromptCodesPost()` */
  static readonly ApiSupervisorCreateCustomPromptCodesPostPath = '/api/Supervisor/CreateCustomPromptCodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `CreateCustomPromptCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  CreateCustomPromptCodes$Response(params?: CreateCustomPromptCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return CreateCustomPromptCodes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `CreateCustomPromptCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  CreateCustomPromptCodes(params?: CreateCustomPromptCodes$Params, context?: HttpContext): Observable<void> {
    return this.CreateCustomPromptCodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMovePromptCodeUpPost()` */
  static readonly ApiSupervisorMovePromptCodeUpPostPath = '/api/Supervisor/MovePromptCodeUp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MovePromptCodeUp()` instead.
   *
   * This method doesn't expect any request body.
   */
  MovePromptCodeUp$Response(params?: MovePromptCodeUp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MovePromptCodeUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MovePromptCodeUp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MovePromptCodeUp(params?: MovePromptCodeUp$Params, context?: HttpContext): Observable<void> {
    return this.MovePromptCodeUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMovePromptCodeDownPost()` */
  static readonly ApiSupervisorMovePromptCodeDownPostPath = '/api/Supervisor/MovePromptCodeDown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MovePromptCodeDown()` instead.
   *
   * This method doesn't expect any request body.
   */
  MovePromptCodeDown$Response(params?: MovePromptCodeDown$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MovePromptCodeDown(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MovePromptCodeDown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MovePromptCodeDown(params?: MovePromptCodeDown$Params, context?: HttpContext): Observable<void> {
    return this.MovePromptCodeDown$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetSkillAreasGet()` */
  static readonly ApiSupervisorGetSkillAreasGetPath = '/api/Supervisor/GetSkillAreas';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSkillAreas()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSkillAreas$Response(params?: GetSkillAreas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SkillAreaModel>>> {
    return GetSkillAreas(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSkillAreas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSkillAreas(params?: GetSkillAreas$Params, context?: HttpContext): Observable<Array<SkillAreaModel>> {
    return this.GetSkillAreas$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SkillAreaModel>>): Array<SkillAreaModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveSkillAreaPost()` */
  static readonly ApiSupervisorSaveSkillAreaPostPath = '/api/Supervisor/SaveSkillArea';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveSkillArea()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSkillArea$Response(params?: SaveSkillArea$Params, context?: HttpContext): Observable<StrictHttpResponse<SkillAreaModel>> {
    return SaveSkillArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveSkillArea$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSkillArea(params?: SaveSkillArea$Params, context?: HttpContext): Observable<SkillAreaModel> {
    return this.SaveSkillArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<SkillAreaModel>): SkillAreaModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkSkillAreaAsDeletedPost()` */
  static readonly ApiSupervisorMarkSkillAreaAsDeletedPostPath = '/api/Supervisor/MarkSkillAreaAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkSkillAreaAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkSkillAreaAsDeleted$Response(params?: MarkSkillAreaAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkSkillAreaAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkSkillAreaAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkSkillAreaAsDeleted(params?: MarkSkillAreaAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkSkillAreaAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRestoreSkillAreaPost()` */
  static readonly ApiSupervisorRestoreSkillAreaPostPath = '/api/Supervisor/RestoreSkillArea';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreSkillArea()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreSkillArea$Response(params?: RestoreSkillArea$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreSkillArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreSkillArea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreSkillArea(params?: RestoreSkillArea$Params, context?: HttpContext): Observable<void> {
    return this.RestoreSkillArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetAllPatientsGet()` */
  static readonly ApiSupervisorGetAllPatientsGetPath = '/api/Supervisor/GetAllPatients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetAllPatients()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAllPatients$Response(params?: GetAllPatients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientModel>>> {
    return GetAllPatients(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetAllPatients$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAllPatients(params?: GetAllPatients$Params, context?: HttpContext): Observable<Array<PatientModel>> {
    return this.GetAllPatients$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientModel>>): Array<PatientModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientProgramsGet()` */
  static readonly ApiSupervisorGetPatientProgramsGetPath = '/api/Supervisor/GetPatientPrograms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientPrograms()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientPrograms$Response(params?: GetPatientPrograms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientProgramModel>>> {
    return GetPatientPrograms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientPrograms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientPrograms(params?: GetPatientPrograms$Params, context?: HttpContext): Observable<Array<PatientProgramModel>> {
    return this.GetPatientPrograms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientProgramModel>>): Array<PatientProgramModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientProgramContentGet()` */
  static readonly ApiSupervisorGetPatientProgramContentGetPath = '/api/Supervisor/GetPatientProgramContent';

  GetPatientProgramContent$Response(params?: GetPatientProgramContent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientProgramModel>> {
    return GetPatientProgramContent(this.http, this.rootUrl, params, context);
  }

  GetPatientProgramContent(params?: GetPatientProgramContent$Params, context?: HttpContext): Observable<PatientProgramModel> {
    return this.GetPatientProgramContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientProgramModel>): PatientProgramModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientTargetContentGet()` */
  static readonly ApiSupervisorGetPatientTargetContentGetPath = '/api/Supervisor/GetPatientTargetContent';

  GetPatientTargetContent$Response(params?: GetPatientTargetContent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetModel>> {
    return GetPatientTargetContent(this.http, this.rootUrl, params, context);
  }

  GetPatientTargetContent(params?: GetPatientTargetContent$Params, context?: HttpContext): Observable<PatientTargetModel> {
    return this.GetPatientTargetContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientTargetModel>): PatientTargetModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientPlaylistContentGet()` */
  static readonly ApiSupervisorGetPatientPlaylistContentGetPath = '/api/Supervisor/GetPatientPlaylistContent';

  GetPatientPlaylistContent$Response(params?: GetPatientPlaylistContent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientPlaylistModel>> {
    return GetPatientPlaylistContent(this.http, this.rootUrl, params, context);
  }

  GetPatientPlaylistContent(params?: GetPatientPlaylistContent$Params, context?: HttpContext): Observable<PatientPlaylistModel> {
    return this.GetPatientPlaylistContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientPlaylistModel>): PatientPlaylistModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePatientProgramPost()` */
  static readonly ApiSupervisorSavePatientProgramPostPath = '/api/Supervisor/SavePatientProgram';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientProgram()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientProgram$Response(params?: SavePatientProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientProgramModel>> {
    return SavePatientProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientProgram$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientProgram(params?: SavePatientProgram$Params, context?: HttpContext): Observable<PatientProgramModel> {
    return this.SavePatientProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientProgramModel>): PatientProgramModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkPatientProgramAsDeletedPost()` */
  static readonly ApiSupervisorMarkPatientProgramAsDeletedPostPath = '/api/Supervisor/MarkPatientProgramAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkPatientProgramAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPatientProgramAsDeleted$Response(params?: MarkPatientProgramAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkPatientProgramAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkPatientProgramAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPatientProgramAsDeleted(params?: MarkPatientProgramAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkPatientProgramAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRestorePatientProgramPost()` */
  static readonly ApiSupervisorRestorePatientProgramPostPath = '/api/Supervisor/RestorePatientProgram';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestorePatientProgram()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientProgram$Response(params?: RestorePatientProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestorePatientProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestorePatientProgram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientProgram(params?: RestorePatientProgram$Params, context?: HttpContext): Observable<void> {
    return this.RestorePatientProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientPlaylistsGet()` */
  static readonly ApiSupervisorGetPatientPlaylistsGetPath = '/api/Supervisor/GetPatientPlaylists';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientPlaylists()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientPlaylists$Response(params?: GetPatientPlaylists$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientPlaylistModel>>> {
    return GetPatientPlaylists(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientPlaylists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientPlaylists(params?: GetPatientPlaylists$Params, context?: HttpContext): Observable<Array<PatientPlaylistModel>> {
    return this.GetPatientPlaylists$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientPlaylistModel>>): Array<PatientPlaylistModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePatientPlaylistPost()` */
  static readonly ApiSupervisorSavePatientPlaylistPostPath = '/api/Supervisor/SavePatientPlaylist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientPlaylist()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientPlaylist$Response(params?: SavePatientPlaylist$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientPlaylistModel>> {
    return SavePatientPlaylist(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientPlaylist$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientPlaylist(params?: SavePatientPlaylist$Params, context?: HttpContext): Observable<PatientPlaylistModel> {
    return this.SavePatientPlaylist$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientPlaylistModel>): PatientPlaylistModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkPatientPlaylistAsDeletedPost()` */
  static readonly ApiSupervisorMarkPatientPlaylistAsDeletedPostPath = '/api/Supervisor/MarkPatientPlaylistAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkPatientPlaylistAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPatientPlaylistAsDeleted$Response(params?: MarkPatientPlaylistAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkPatientPlaylistAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkPatientPlaylistAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPatientPlaylistAsDeleted(params?: MarkPatientPlaylistAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkPatientPlaylistAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRestorePatientPlaylistPost()` */
  static readonly ApiSupervisorRestorePatientPlaylistPostPath = '/api/Supervisor/RestorePatientPlaylist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestorePatientPlaylist()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientPlaylist$Response(params?: RestorePatientPlaylist$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestorePatientPlaylist(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestorePatientPlaylist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientPlaylist(params?: RestorePatientPlaylist$Params, context?: HttpContext): Observable<void> {
    return this.RestorePatientPlaylist$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientTargetsGet()` */
  static readonly ApiSupervisorGetPatientTargetsGetPath = '/api/Supervisor/GetPatientTargets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTargets$Response(params?: GetPatientTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetModel>>> {
    return GetPatientTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTargets(params?: GetPatientTargets$Params, context?: HttpContext): Observable<Array<PatientTargetModel>> {
    return this.GetPatientTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientTargetModel>>): Array<PatientTargetModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientTreatmentGoalsGet()` */
  static readonly ApiSupervisorGetPatientTreatmentGoalsGetPath = '/api/Supervisor/GetPatientTreatmentGoals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientTreatmentGoals()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTreatmentGoals$Response(params?: GetPatientTreatmentGoals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TreatmentGoalModel>>> {
    return GetPatientTreatmentGoals(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientTreatmentGoals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTreatmentGoals(params?: GetPatientTreatmentGoals$Params, context?: HttpContext): Observable<Array<TreatmentGoalModel>> {
    return this.GetPatientTreatmentGoals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TreatmentGoalModel>>): Array<TreatmentGoalModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientSkillAcquisitionGoalsGet()` */
  static readonly ApiSupervisorGetPatientSkillAcquisitionGoalsGetPath = '/api/Supervisor/GetPatientSkillAcquisitionGoals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientSkillAcquisitionGoals()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSkillAcquisitionGoals$Response(params?: GetPatientSkillAcquisitionGoals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SkillAcquisitionGoalModel>>> {
    return GetPatientSkillAcquisitionGoals(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientSkillAcquisitionGoals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSkillAcquisitionGoals(params?: GetPatientSkillAcquisitionGoals$Params, context?: HttpContext): Observable<Array<SkillAcquisitionGoalModel>> {
    return this.GetPatientSkillAcquisitionGoals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SkillAcquisitionGoalModel>>): Array<SkillAcquisitionGoalModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientSkillAcquisitionObjectivesGet()` */
  static readonly ApiSupervisorGetPatientSkillAcquisitionObjectivesGetPath = '/api/Supervisor/GetPatientSkillAcquisitionObjectives';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientSkillAcquisitionObjectives()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSkillAcquisitionObjectives$Response(params?: GetPatientSkillAcquisitionObjectives$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SkillAcquisitionObjectiveModel>>> {
    return GetPatientSkillAcquisitionObjectives(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientSkillAcquisitionObjectives$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSkillAcquisitionObjectives(params?: GetPatientSkillAcquisitionObjectives$Params, context?: HttpContext): Observable<Array<SkillAcquisitionObjectiveModel>> {
    return this.GetPatientSkillAcquisitionObjectives$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SkillAcquisitionObjectiveModel>>): Array<SkillAcquisitionObjectiveModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientBehaviorGoalsGet()` */
  static readonly ApiSupervisorGetPatientBehaviorGoalsGetPath = '/api/Supervisor/GetPatientBehaviorGoals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorGoals()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorGoals$Response(params?: GetPatientBehaviorGoals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorGoalModel>>> {
    return GetPatientBehaviorGoals(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorGoals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorGoals(params?: GetPatientBehaviorGoals$Params, context?: HttpContext): Observable<Array<BehaviorGoalModel>> {
    return this.GetPatientBehaviorGoals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BehaviorGoalModel>>): Array<BehaviorGoalModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorArchiveTargetPost()` */
  static readonly ApiSupervisorArchiveTargetPostPath = '/api/Supervisor/ArchiveTarget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ArchiveTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  ArchiveTarget$Response(params?: ArchiveTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ArchiveTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ArchiveTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ArchiveTarget(params?: ArchiveTarget$Params, context?: HttpContext): Observable<void> {
    return this.ArchiveTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorUpdateTargetStatusPost()` */
  static readonly ApiSupervisorUpdateTargetStatusPostPath = '/api/Supervisor/UpdateTargetStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UpdateTargetStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  UpdateTargetStatus$Response(params?: UpdateTargetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UpdateTargetStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UpdateTargetStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  UpdateTargetStatus(params?: UpdateTargetStatus$Params, context?: HttpContext): Observable<void> {
    return this.UpdateTargetStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorUploadPatientInstructionsAttachmentPost()` */
  static readonly ApiSupervisorUploadPatientInstructionsAttachmentPostPath = '/api/Supervisor/UploadPatientInstructionsAttachment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadPatientInstructionsAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadPatientInstructionsAttachment$Response(params?: UploadPatientInstructionsAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UploadPatientInstructionsAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UploadPatientInstructionsAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadPatientInstructionsAttachment(params?: UploadPatientInstructionsAttachment$Params, context?: HttpContext): Observable<void> {
    return this.UploadPatientInstructionsAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorUploadTargetAttachmentPost()` */
  static readonly ApiSupervisorUploadTargetAttachmentPostPath = '/api/Supervisor/UploadTargetAttachment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadTargetAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadTargetAttachment$Response(params?: UploadTargetAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UploadTargetAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UploadTargetAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadTargetAttachment(params?: UploadTargetAttachment$Params, context?: HttpContext): Observable<void> {
    return this.UploadTargetAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorDeletePatientInstructionAttachmentPost()` */
  static readonly ApiSupervisorDeletePatientInstructionAttachmentPostPath = '/api/Supervisor/DeletePatientInstructionAttachment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeletePatientInstructionAttachment()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeletePatientInstructionAttachment$Response(params?: DeletePatientInstructionAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeletePatientInstructionAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeletePatientInstructionAttachment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeletePatientInstructionAttachment(params?: DeletePatientInstructionAttachment$Params, context?: HttpContext): Observable<void> {
    return this.DeletePatientInstructionAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorDeleteTargetAttachmentPost()` */
  static readonly ApiSupervisorDeleteTargetAttachmentPostPath = '/api/Supervisor/DeleteTargetAttachment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteTargetAttachment()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteTargetAttachment$Response(params?: DeleteTargetAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteTargetAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteTargetAttachment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteTargetAttachment(params?: DeleteTargetAttachment$Params, context?: HttpContext): Observable<void> {
    return this.DeleteTargetAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorUpdateTargetInstructionsPost()` */
  static readonly ApiSupervisorUpdateTargetInstructionsPostPath = '/api/Supervisor/UpdateTargetInstructions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UpdateTargetInstructions()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  UpdateTargetInstructions$Response(params?: UpdateTargetInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UpdateTargetInstructions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UpdateTargetInstructions$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  UpdateTargetInstructions(params?: UpdateTargetInstructions$Params, context?: HttpContext): Observable<void> {
    return this.UpdateTargetInstructions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePatientTargetPost()` */
  static readonly ApiSupervisorSavePatientTargetPostPath = '/api/Supervisor/SavePatientTarget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientTarget()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientTarget$Response(params?: SavePatientTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetModel>> {
    return SavePatientTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientTarget$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientTarget(params?: SavePatientTarget$Params, context?: HttpContext): Observable<PatientTargetModel> {
    return this.SavePatientTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientTargetModel>): PatientTargetModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorDuplicatePatientTargetPost()` */
  static readonly ApiSupervisorDuplicatePatientTargetPostPath = '/api/Supervisor/DuplicatePatientTarget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DuplicatePatientTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  DuplicatePatientTarget$Response(params?: DuplicatePatientTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetModel>> {
    return DuplicatePatientTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DuplicatePatientTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DuplicatePatientTarget(params?: DuplicatePatientTarget$Params, context?: HttpContext): Observable<PatientTargetModel> {
    return this.DuplicatePatientTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientTargetModel>): PatientTargetModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkPatientTargetAsDeletedPost()` */
  static readonly ApiSupervisorMarkPatientTargetAsDeletedPostPath = '/api/Supervisor/MarkPatientTargetAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkPatientTargetAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPatientTargetAsDeleted$Response(params?: MarkPatientTargetAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkPatientTargetAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkPatientTargetAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkPatientTargetAsDeleted(params?: MarkPatientTargetAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkPatientTargetAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRestorePatientTargetPost()` */
  static readonly ApiSupervisorRestorePatientTargetPostPath = '/api/Supervisor/RestorePatientTarget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestorePatientTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientTarget$Response(params?: RestorePatientTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestorePatientTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestorePatientTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientTarget(params?: RestorePatientTarget$Params, context?: HttpContext): Observable<void> {
    return this.RestorePatientTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientRemindersGet()` */
  static readonly ApiSupervisorGetPatientRemindersGetPath = '/api/Supervisor/GetPatientReminders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientReminders()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientReminders$Response(params?: GetPatientReminders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientReminderModel>>> {
    return GetPatientReminders(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientReminders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientReminders(params?: GetPatientReminders$Params, context?: HttpContext): Observable<Array<PatientReminderModel>> {
    return this.GetPatientReminders$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientReminderModel>>): Array<PatientReminderModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePatientReminderPost()` */
  static readonly ApiSupervisorSavePatientReminderPostPath = '/api/Supervisor/SavePatientReminder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientReminder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientReminder$Response(params?: SavePatientReminder$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientReminderModel>> {
    return SavePatientReminder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientReminder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientReminder(params?: SavePatientReminder$Params, context?: HttpContext): Observable<PatientReminderModel> {
    return this.SavePatientReminder$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientReminderModel>): PatientReminderModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorDeletePatientReminderPost()` */
  static readonly ApiSupervisorDeletePatientReminderPostPath = '/api/Supervisor/DeletePatientReminder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeletePatientReminder()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeletePatientReminder$Response(params?: DeletePatientReminder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeletePatientReminder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeletePatientReminder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeletePatientReminder(params?: DeletePatientReminder$Params, context?: HttpContext): Observable<void> {
    return this.DeletePatientReminder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRestorePatientReminderPost()` */
  static readonly ApiSupervisorRestorePatientReminderPostPath = '/api/Supervisor/RestorePatientReminder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestorePatientReminder()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientReminder$Response(params?: RestorePatientReminder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestorePatientReminder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestorePatientReminder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestorePatientReminder(params?: RestorePatientReminder$Params, context?: HttpContext): Observable<void> {
    return this.RestorePatientReminder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetCurrentMaintenanceCriteriaFullGet()` */
  static readonly ApiSupervisorGetCurrentMaintenanceCriteriaFullGetPath = '/api/Supervisor/GetCurrentMaintenanceCriteriaFull';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetCurrentMaintenanceCriteriaFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentMaintenanceCriteriaFull$Response(params?: GetCurrentMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<StrictHttpResponse<MaintenanceCriteriaFullModel>> {
    return GetCurrentMaintenanceCriteriaFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetCurrentMaintenanceCriteriaFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentMaintenanceCriteriaFull(params?: GetCurrentMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<MaintenanceCriteriaFullModel> {
    return this.GetCurrentMaintenanceCriteriaFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<MaintenanceCriteriaFullModel>): MaintenanceCriteriaFullModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetMaintenanceCriteriaFullGet()` */
  static readonly ApiSupervisorGetMaintenanceCriteriaFullGetPath = '/api/Supervisor/GetMaintenanceCriteriaFull';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetMaintenanceCriteriaFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMaintenanceCriteriaFull$Response(params?: GetMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<StrictHttpResponse<MaintenanceCriteriaFullModel>> {
    return GetMaintenanceCriteriaFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetMaintenanceCriteriaFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMaintenanceCriteriaFull(params?: GetMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<MaintenanceCriteriaFullModel> {
    return this.GetMaintenanceCriteriaFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<MaintenanceCriteriaFullModel>): MaintenanceCriteriaFullModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveMaintenanceCriteriaFullPost()` */
  static readonly ApiSupervisorSaveMaintenanceCriteriaFullPostPath = '/api/Supervisor/SaveMaintenanceCriteriaFull';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveMaintenanceCriteriaFull()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveMaintenanceCriteriaFull$Response(params?: SaveMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveMaintenanceCriteriaFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveMaintenanceCriteriaFull$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveMaintenanceCriteriaFull(params?: SaveMaintenanceCriteriaFull$Params, context?: HttpContext): Observable<void> {
    return this.SaveMaintenanceCriteriaFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRemoveCustomMaintenanceCriteriaPost()` */
  static readonly ApiSupervisorRemoveCustomMaintenanceCriteriaPostPath = '/api/Supervisor/RemoveCustomMaintenanceCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RemoveCustomMaintenanceCriteria()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  RemoveCustomMaintenanceCriteria$Response(params?: RemoveCustomMaintenanceCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RemoveCustomMaintenanceCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RemoveCustomMaintenanceCriteria$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  RemoveCustomMaintenanceCriteria(params?: RemoveCustomMaintenanceCriteria$Params, context?: HttpContext): Observable<void> {
    return this.RemoveCustomMaintenanceCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetProbeCriteriaGet()` */
  static readonly ApiSupervisorGetProbeCriteriaGetPath = '/api/Supervisor/GetProbeCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetProbeCriteria()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetProbeCriteria$Response(params?: GetProbeCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<ProbeCriteriaModel>> {
    return GetProbeCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetProbeCriteria$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetProbeCriteria(params?: GetProbeCriteria$Params, context?: HttpContext): Observable<ProbeCriteriaModel> {
    return this.GetProbeCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProbeCriteriaModel>): ProbeCriteriaModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveProbeCriteriaPost()` */
  static readonly ApiSupervisorSaveProbeCriteriaPostPath = '/api/Supervisor/SaveProbeCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveProbeCriteria()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveProbeCriteria$Response(params?: SaveProbeCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveProbeCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveProbeCriteria$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveProbeCriteria(params?: SaveProbeCriteria$Params, context?: HttpContext): Observable<void> {
    return this.SaveProbeCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetMaintananceLevelsGet()` */
  static readonly ApiSupervisorGetMaintananceLevelsGetPath = '/api/Supervisor/GetMaintananceLevels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetMaintananceLevels()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMaintananceLevels$Response(params?: GetMaintananceLevels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MaintananceLevelModel>>> {
    return GetMaintananceLevels(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetMaintananceLevels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMaintananceLevels(params?: GetMaintananceLevels$Params, context?: HttpContext): Observable<Array<MaintananceLevelModel>> {
    return this.GetMaintananceLevels$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MaintananceLevelModel>>): Array<MaintananceLevelModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetMasteryCriteriaGet()` */
  static readonly ApiSupervisorGetMasteryCriteriaGetPath = '/api/Supervisor/GetMasteryCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetMasteryCriteria()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMasteryCriteria$Response(params?: GetMasteryCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<MasteryCriteriaModel>> {
    return GetMasteryCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetMasteryCriteria$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMasteryCriteria(params?: GetMasteryCriteria$Params, context?: HttpContext): Observable<MasteryCriteriaModel> {
    return this.GetMasteryCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<MasteryCriteriaModel>): MasteryCriteriaModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveMasteryCriteriaPost()` */
  static readonly ApiSupervisorSaveMasteryCriteriaPostPath = '/api/Supervisor/SaveMasteryCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveMasteryCriteria()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveMasteryCriteria$Response(params?: SaveMasteryCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveMasteryCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveMasteryCriteria$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveMasteryCriteria(params?: SaveMasteryCriteria$Params, context?: HttpContext): Observable<void> {
    return this.SaveMasteryCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorRemoveCustomMasteryCriteriaPost()` */
  static readonly ApiSupervisorRemoveCustomMasteryCriteriaPostPath = '/api/Supervisor/RemoveCustomMasteryCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RemoveCustomMasteryCriteria()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  RemoveCustomMasteryCriteria$Response(params?: RemoveCustomMasteryCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RemoveCustomMasteryCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RemoveCustomMasteryCriteria$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  RemoveCustomMasteryCriteria(params?: RemoveCustomMasteryCriteria$Params, context?: HttpContext): Observable<void> {
    return this.RemoveCustomMasteryCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorImportBehaviorsFromBipPost()` */
  static readonly ApiSupervisorImportBehaviorsFromBipPostPath = '/api/Supervisor/ImportBehaviorsFromBIP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ImportBehaviorsFromBIP()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportBehaviorsFromBIP$Response(params?: ImportBehaviorsFromBIP$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ImportBehaviorsFromBIP(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ImportBehaviorsFromBIP$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportBehaviorsFromBIP(params?: ImportBehaviorsFromBIP$Params, context?: HttpContext): Observable<void> {
    return this.ImportBehaviorsFromBIP$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorImportAntecedentsFromBipPost()` */
  static readonly ApiSupervisorImportAntecedentsFromBipPostPath = '/api/Supervisor/ImportAntecedentsFromBIP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ImportAntecedentsFromBIP()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportAntecedentsFromBIP$Response(params?: ImportAntecedentsFromBIP$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ImportAntecedentsFromBIP(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ImportAntecedentsFromBIP$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportAntecedentsFromBIP(params?: ImportAntecedentsFromBIP$Params, context?: HttpContext): Observable<void> {
    return this.ImportAntecedentsFromBIP$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorImportConsequencesFromBipPost()` */
  static readonly ApiSupervisorImportConsequencesFromBipPostPath = '/api/Supervisor/ImportConsequencesFromBIP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ImportConsequencesFromBIP()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportConsequencesFromBIP$Response(params?: ImportConsequencesFromBIP$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ImportConsequencesFromBIP(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ImportConsequencesFromBIP$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportConsequencesFromBIP(params?: ImportConsequencesFromBIP$Params, context?: HttpContext): Observable<void> {
    return this.ImportConsequencesFromBIP$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorImportProgramsFromBspPost()` */
  static readonly ApiSupervisorImportProgramsFromBspPostPath = '/api/Supervisor/ImportProgramsFromBSP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ImportProgramsFromBSP()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportProgramsFromBSP$Response(params?: ImportProgramsFromBSP$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ImportProgramsFromBSP(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ImportProgramsFromBSP$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportProgramsFromBSP(params?: ImportProgramsFromBSP$Params, context?: HttpContext): Observable<string> {
    return this.ImportProgramsFromBSP$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiSupervisorImportSkillAreasFromBspPost()` */
  static readonly ApiSupervisorImportSkillAreasFromBspPostPath = '/api/Supervisor/ImportSkillAreasFromBSP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ImportSkillAreasFromBSP()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportSkillAreasFromBSP$Response(params?: ImportSkillAreasFromBSP$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ImportSkillAreasFromBSP(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ImportSkillAreasFromBSP$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ImportSkillAreasFromBSP(params?: ImportSkillAreasFromBSP$Params, context?: HttpContext): Observable<string> {
    return this.ImportSkillAreasFromBSP$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiSupervisorImportPatientTargetsFromFilePost()` */
  static readonly ApiSupervisorImportPatientTargetsFromFilePostPath = '/api/Supervisor/ImportPatientTargetsFromFile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ImportPatientTargetsFromFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ImportPatientTargetsFromFile$Response(params?: ImportPatientTargetsFromFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ImportPatientTargetsFromFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ImportPatientTargetsFromFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ImportPatientTargetsFromFile(params?: ImportPatientTargetsFromFile$Params, context?: HttpContext): Observable<void> {
    return this.ImportPatientTargetsFromFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePatientInstructionsPost()` */
  static readonly ApiSupervisorSavePatientInstructionsPostPath = '/api/Supervisor/SavePatientInstructions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientInstructions()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientInstructions$Response(params?: SavePatientInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SavePatientInstructions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientInstructions$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientInstructions(params?: SavePatientInstructions$Params, context?: HttpContext): Observable<void> {
    return this.SavePatientInstructions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientInstructionsGet()` */
  static readonly ApiSupervisorGetPatientInstructionsGetPath = '/api/Supervisor/GetPatientInstructions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientInstructions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientInstructions$Response(params?: GetPatientInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientInstructionsModel>> {
    return GetPatientInstructions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientInstructions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientInstructions(params?: GetPatientInstructions$Params, context?: HttpContext): Observable<PatientInstructionsModel> {
    return this.GetPatientInstructions$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientInstructionsModel>): PatientInstructionsModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePatientNotesPost()` */
  static readonly ApiSupervisorSavePatientNotesPostPath = '/api/Supervisor/SavePatientNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientNotes()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientNotes$Response(params?: SavePatientNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SavePatientNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientNotes$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientNotes(params?: SavePatientNotes$Params, context?: HttpContext): Observable<void> {
    return this.SavePatientNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientNotesGet()` */
  static readonly ApiSupervisorGetPatientNotesGetPath = '/api/Supervisor/GetPatientNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientNotes$Response(params?: GetPatientNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientNotesModel>> {
    return GetPatientNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientNotes(params?: GetPatientNotes$Params, context?: HttpContext): Observable<PatientNotesModel> {
    return this.GetPatientNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientNotesModel>): PatientNotesModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientInstructionAttachmentsGet()` */
  static readonly ApiSupervisorGetPatientInstructionAttachmentsGetPath = '/api/Supervisor/GetPatientInstructionAttachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientInstructionAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientInstructionAttachments$Response(params?: GetPatientInstructionAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneralAttachmentModel>>> {
    return GetPatientInstructionAttachments(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientInstructionAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientInstructionAttachments(params?: GetPatientInstructionAttachments$Params, context?: HttpContext): Observable<Array<GeneralAttachmentModel>> {
    return this.GetPatientInstructionAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GeneralAttachmentModel>>): Array<GeneralAttachmentModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetTargetAttachmentsGet()` */
  static readonly ApiSupervisorGetTargetAttachmentsGetPath = '/api/Supervisor/GetTargetAttachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTargetAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetAttachments$Response(params?: GetTargetAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneralAttachmentModel>>> {
    return GetTargetAttachments(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTargetAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetAttachments(params?: GetTargetAttachments$Params, context?: HttpContext): Observable<Array<GeneralAttachmentModel>> {
    return this.GetTargetAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GeneralAttachmentModel>>): Array<GeneralAttachmentModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientBipInterventionsGet()` */
  static readonly ApiSupervisorGetPatientBipInterventionsGetPath = '/api/Supervisor/GetPatientBIPInterventions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBIPInterventions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBIPInterventions$Response(params?: GetPatientBIPInterventions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return GetPatientBIPInterventions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBIPInterventions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBIPInterventions(params?: GetPatientBIPInterventions$Params, context?: HttpContext): Observable<Array<string>> {
    return this.GetPatientBIPInterventions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkProgramNoteAsReadPost()` */
  static readonly ApiSupervisorMarkProgramNoteAsReadPostPath = '/api/Supervisor/MarkProgramNoteAsRead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkProgramNoteAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkProgramNoteAsRead$Response(params?: MarkProgramNoteAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkProgramNoteAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkProgramNoteAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkProgramNoteAsRead(params?: MarkProgramNoteAsRead$Params, context?: HttpContext): Observable<void> {
    return this.MarkProgramNoteAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkTargetNoteAsReadPost()` */
  static readonly ApiSupervisorMarkTargetNoteAsReadPostPath = '/api/Supervisor/MarkTargetNoteAsRead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkTargetNoteAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkTargetNoteAsRead$Response(params?: MarkTargetNoteAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkTargetNoteAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkTargetNoteAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkTargetNoteAsRead(params?: MarkTargetNoteAsRead$Params, context?: HttpContext): Observable<void> {
    return this.MarkTargetNoteAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetTargetRawDataGet()` */
  static readonly ApiSupervisorGetTargetRawDataGetPath = '/api/Supervisor/GetTargetRawData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTargetRawData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetRawData$Response(params?: GetTargetRawData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetDataModel>>> {
    return GetTargetRawData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTargetRawData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetRawData(params?: GetTargetRawData$Params, context?: HttpContext): Observable<Array<PatientTargetDataModel>> {
    return this.GetTargetRawData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientTargetDataModel>>): Array<PatientTargetDataModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetBehaviorRawDataGet()` */
  static readonly ApiSupervisorGetBehaviorRawDataGetPath = '/api/Supervisor/GetBehaviorRawData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBehaviorRawData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorRawData$Response(params?: GetBehaviorRawData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorDataModel>>> {
    return GetBehaviorRawData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBehaviorRawData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorRawData(params?: GetBehaviorRawData$Params, context?: HttpContext): Observable<Array<PatientBehaviorDataModel>> {
    return this.GetBehaviorRawData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorDataModel>>): Array<PatientBehaviorDataModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientOverviewDataGet()` */
  static readonly ApiSupervisorGetPatientOverviewDataGetPath = '/api/Supervisor/GetPatientOverviewData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientOverviewData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientOverviewData$Response(params?: GetPatientOverviewData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientOverviewDataModel>> {
    return GetPatientOverviewData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientOverviewData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientOverviewData(params?: GetPatientOverviewData$Params, context?: HttpContext): Observable<PatientOverviewDataModel> {
    return this.GetPatientOverviewData$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientOverviewDataModel>): PatientOverviewDataModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMergeTargetsMergeTargetsPost()` */
  static readonly ApiSupervisorMergeTargetsMergeTargetsPostPath = '/api/Supervisor/MergeTargets/MergeTargets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MergeTargets()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MergeTargets$Response(params?: MergeTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MergeTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MergeTargets$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MergeTargets(params?: MergeTargets$Params, context?: HttpContext): Observable<void> {
    return this.MergeTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMergeBehaviorsMergeBehaviorsPost()` */
  static readonly ApiSupervisorMergeBehaviorsMergeBehaviorsPostPath = '/api/Supervisor/MergeBehaviors/MergeBehaviors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MergeBehaviors()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MergeBehaviors$Response(params?: MergeBehaviors$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MergeBehaviors(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MergeBehaviors$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MergeBehaviors(params?: MergeBehaviors$Params, context?: HttpContext): Observable<void> {
    return this.MergeBehaviors$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMoveSessionDataMergeSessionsPost()` */
  static readonly ApiSupervisorMoveSessionDataMergeSessionsPostPath = '/api/Supervisor/MoveSessionData/MergeSessions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MoveSessionData()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MoveSessionData$Response(params?: MoveSessionData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MoveSessionData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MoveSessionData$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MoveSessionData(params?: MoveSessionData$Params, context?: HttpContext): Observable<void> {
    return this.MoveSessionData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSavePlaylistOrderPost()` */
  static readonly ApiSupervisorSavePlaylistOrderPostPath = '/api/Supervisor/SavePlaylistOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePlaylistOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePlaylistOrder$Response(params?: SavePlaylistOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SavePlaylistOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePlaylistOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePlaylistOrder(params?: SavePlaylistOrder$Params, context?: HttpContext): Observable<void> {
    return this.SavePlaylistOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveProgramOrderPost()` */
  static readonly ApiSupervisorSaveProgramOrderPostPath = '/api/Supervisor/SaveProgramOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveProgramOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveProgramOrder$Response(params?: SaveProgramOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveProgramOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveProgramOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveProgramOrder(params?: SaveProgramOrder$Params, context?: HttpContext): Observable<void> {
    return this.SaveProgramOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorSaveTargetOrderPost()` */
  static readonly ApiSupervisorSaveTargetOrderPostPath = '/api/Supervisor/SaveTargetOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTargetOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveTargetOrder$Response(params?: SaveTargetOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveTargetOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTargetOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveTargetOrder(params?: SaveTargetOrder$Params, context?: HttpContext): Observable<void> {
    return this.SaveTargetOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkMultiplePatientPlaylistsAsDeletedPost()` */
  static readonly ApiSupervisorMarkMultiplePatientPlaylistsAsDeletedPostPath = '/api/Supervisor/MarkMultiplePatientPlaylistsAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkMultiplePatientPlaylistsAsDeleted()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientPlaylistsAsDeleted$Response(params?: MarkMultiplePatientPlaylistsAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkMultiplePatientPlaylistsAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkMultiplePatientPlaylistsAsDeleted$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientPlaylistsAsDeleted(params?: MarkMultiplePatientPlaylistsAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkMultiplePatientPlaylistsAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkMultiplePatientProgramsAsDeletedPost()` */
  static readonly ApiSupervisorMarkMultiplePatientProgramsAsDeletedPostPath = '/api/Supervisor/MarkMultiplePatientProgramsAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkMultiplePatientProgramsAsDeleted()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientProgramsAsDeleted$Response(params?: MarkMultiplePatientProgramsAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkMultiplePatientProgramsAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkMultiplePatientProgramsAsDeleted$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientProgramsAsDeleted(params?: MarkMultiplePatientProgramsAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkMultiplePatientProgramsAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorMarkMultiplePatientTargetsAsDeletedPost()` */
  static readonly ApiSupervisorMarkMultiplePatientTargetsAsDeletedPostPath = '/api/Supervisor/MarkMultiplePatientTargetsAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkMultiplePatientTargetsAsDeleted()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientTargetsAsDeleted$Response(params?: MarkMultiplePatientTargetsAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkMultiplePatientTargetsAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkMultiplePatientTargetsAsDeleted$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientTargetsAsDeleted(params?: MarkMultiplePatientTargetsAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkMultiplePatientTargetsAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetChangeLogGet()` */
  static readonly ApiSupervisorGetChangeLogGetPath = '/api/Supervisor/GetChangeLog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetChangeLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetChangeLog$Response(params?: GetChangeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChangeLogModel>>> {
    return GetChangeLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetChangeLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetChangeLog(params?: GetChangeLog$Params, context?: HttpContext): Observable<Array<ChangeLogModel>> {
    return this.GetChangeLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChangeLogModel>>): Array<ChangeLogModel> => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientProgramsDeltaGet()` */
  static readonly ApiSupervisorGetPatientProgramsDeltaGetPath = '/api/Supervisor/GetPatientProgramsDelta';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientProgramsDelta()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientProgramsDelta$Response(params?: GetPatientProgramsDelta$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientProgramsDeltaResponseModel>> {
    return GetPatientProgramsDelta(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientProgramsDelta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientProgramsDelta(params?: GetPatientProgramsDelta$Params, context?: HttpContext): Observable<PatientProgramsDeltaResponseModel> {
    return this.GetPatientProgramsDelta$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientProgramsDeltaResponseModel>): PatientProgramsDeltaResponseModel => r.body)
    );
  }

  /** Path part for operation `apiSupervisorGetPatientTargetsDeltaGet()` */
  static readonly ApiSupervisorGetPatientTargetsDeltaGetPath = '/api/Supervisor/GetPatientTargetsDelta';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientTargetsDelta()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTargetsDelta$Response(params?: GetPatientTargetsDelta$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetsDeltaResponseModel>> {
    return GetPatientTargetsDelta(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientTargetsDelta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTargetsDelta(params?: GetPatientTargetsDelta$Params, context?: HttpContext): Observable<PatientTargetsDeltaResponseModel> {
    return this.GetPatientTargetsDelta$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientTargetsDeltaResponseModel>): PatientTargetsDeltaResponseModel => r.body)
    );
  }

}
